export const RedPin =
  'https://nar.media.audi.com/is/image/audinar/nemo/ca/NoMo/radius-search/RedPin.png?fmt=png-alpha';

export const BlackPin =
  'https://nar.media.audi.com/is/image/audinar/nemo/ca/NoMo/radius-search/BlackPin.png?fmt=png-alpha';

export const disabledMapImage =
  'https://nar.media.audi.com/is/image/audinar/nemo/ca/NoMo/radius-search/disabledMap.png';

export const selectImg =
  'https://nar.media.audi.com/is/image/audinar/nemo/ca/NoMo/radius-search/select.png';

export const selectWhiteImg =
  'https://nar.media.audi.com/is/image/audinar/nemo/ca/NoMo/radius-search/select-white.png';
